// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";
import MuiThemeProvider from "@material-ui/core/styles/MuiThemeProvider";
import Typography from "@material-ui/core/Typography";

import { LightTheme } from "../../global/types/themes";
import { ColorSchema, WhiteText } from "../../global/types/scss";
import { getConferenceId } from "../../global/actions/databaseActions";
import LoadingProgress from "../../global/components/LoadingProgress";
import { CopyRight } from "../containers/CopyRight";

type ErrorPageStatesType = {
  shouldWaiting: boolean
};

class ErrorPage extends Component<*, ErrorPageStatesType> {
  constructor(props) {
    super(props);
    this.state = {
      shouldWaiting: false
    };
  }

  componentDidMount() {
    if (!this.props.isLoaded && this.props.params.conference !== undefined) {
      this.setState({ shouldWaiting: true });
      this.props.actions.getConferenceId(this.props.params.conference, () => null);
    }
  }

  render(): React$Element<*> {
    let display;
    if (this.state.shouldWaiting === false) {
      display = true;
    }
    else {
      if (this.props.db.conference) {
        display = true;
      }
      else {
        display = false;
      }
    }
    return (
      <MuiThemeProvider theme={LightTheme}>
        {display &&
          <div className="mui-form">
            <div className="left-404" style={{ backgroundColor: ColorSchema("primary") }}>
              <div className="white-title left-error-title">
                4
                <svg className="svg-circle">
                  <mask x="0" y="0" id="leftHalf">
                    <rect fill={WhiteText} width="50%" height="100%" x="0"></rect>
                  </mask>
                  <circle fill="transparent" stroke="none" cx="50%" cy="50%" r="50%">
                  </circle>
                  <circle fill={WhiteText} mask="url(#leftHalf)" stroke="none" cx="50%" cy="50%" r="50%"></circle>
                </svg>
              </div>
            </div>
            <div className="right-404">
              <div className="right-error-title" style={{ color: ColorSchema("primary") }}>
                <svg className="svg-circle">
                  <mask x="0" y="0" id="rightHalf">
                    <rect fill={WhiteText} width="50%" height="100%" x="50%"></rect>
                  </mask>
                  <circle fill="transparent" stroke="none" cx="50%" cy="50%" r="50%">
                  </circle>
                  <circle fill={ColorSchema("primary")} mask="url(#rightHalf)" stroke="none" cx="50%" cy="50%" r="50%"></circle>
                </svg>
                4
            </div>
            </div>
            <Typography variant="body1" className="form-text page404-bottom">
              <span className="">{CopyRight}</span>
            </Typography>
          </div>
          ||
          <div className="form-text"><LoadingProgress size={100} /></div>
        }
      </MuiThemeProvider>
    );
  }
}

function mapStateToProps(state) {
  return { db: state.forensic.db };
}

function mapDispatchToProps(dispatch) {
  return { actions: bindActionCreators({ getConferenceId }, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ErrorPage));



// WEBPACK FOOTER //
// ./src/conference/views/ErrorPage.js